import React, { useState } from 'react'
import styled from 'styled-components'
import { CardBody, FormGroup, Form, Input, Button, Label } from 'reactstrap'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { Mail, Lock, Eye, EyeOff } from 'react-feather'
import { useDispatch } from 'react-redux'

import { signInRequest } from '~/store/modules/auth/actions'

function LoginJWT() {
  const dispatch = useDispatch()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  const intl = useIntl()

  const handleLogin = e => {
    e.preventDefault()
    dispatch(signInRequest(email, password))
  }

  const handleShowPass = () => setShowPassword(prevState => !prevState)

  return (
    <>
      <CardBody className="pt-1">
        <Form onSubmit={handleLogin}>
          <Label for="email">{intl.formatMessage({ id: 'Email' }) + ':'}</Label>
          <FormGroup className="position-relative has-icon-left">
            <Input
              type="email"
              id="email"
              autocomplete="username"
              placeholder={intl.formatMessage({ id: 'Your company email' })}
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
            <div className="form-control-position">
              <Mail size={15} />
            </div>
          </FormGroup>

          <Label for="password">
            {intl.formatMessage({ id: 'Password' }) + ':'}
          </Label>
          <FormGroup className="form-label-group position-relative has-icon-left">
            <PasswordContainer>
              <PasswordInput
                id="password"
                autocomplete="current-password"
                type={showPassword ? 'text' : 'password'}
                placeholder={intl.formatMessage({ id: 'Password' })}
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
              {showPassword && (
                <ShowPassButton
                  onClick={handleShowPass}
                  tabIndex="-1"
                  type="button"
                >
                  <Eye size={15} color="#7367F0" />
                </ShowPassButton>
              )}
              {!showPassword && (
                <ShowPassButton
                  onClick={handleShowPass}
                  tabIndex="-1"
                  type="button"
                >
                  <EyeOff size={15} color="#7367F0" />
                </ShowPassButton>
              )}
            </PasswordContainer>
            <div className="form-control-position">
              <Lock size={15} />
            </div>
          </FormGroup>
          <div className="d-flex align-items-center">
            <Button.Ripple color="primary" type="submit">
              {intl.formatMessage({ id: 'Login' })}
            </Button.Ripple>
            <Link className="ml-3" to="/forgot-password">
              {intl.formatMessage({ id: 'Forgot password' })}
            </Link>
          </div>
        </Form>
      </CardBody>
    </>
  )
}

const ShowPassButton = styled.button`
  width: 25px;
  display: flex;
  justify-content: start;
  align-items: center;
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;

  &:focus {
    outline: none;
  }

  &:active {
    outline: none;
  }
`

const PasswordContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 5px;

  &:has(input:focus) {
    border-color: #7367f0 !important;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15) !important;
    outline: 0 !important;
  }

  &:has(input[data-com-onepassword-filled='light']) {
    background-color: rgb(219, 237, 255) !important;
  }
`

const PasswordInput = styled(Input)`
  width: calc(100% - 25px);
  padding-right: 5px !important;
  border: none;

  &:focus {
    box-shadow: none;
  }

  &:focus-visible {
    outline: none;
  }
`

export default LoginJWT
